var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',[_c('get-markdown',{attrs:{"src":"../ReferencesMarkdown.md"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }